export default __webpack_public_path__ + "static/media/icon-next-step-pass-coopeuch-gray.2d7c30a6.svg";